// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
var rem = function(px) {
    var base = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 16;
    if (base === 0) {
        throw new Error('Base pixel value cannot be zero');
    }
    return "".concat(px / base, "rem");
};
var inter = "'Inter', sans-serif";
var interTight = "'Inter Tight', sans-serif";
var ibmPlexSans = "'IBM Plex Sans', sans-serif";
export var typography = {
    fontSize: 14,
    fontFamily: inter,
    h1: {
        fontFamily: inter,
        fontWeight: 600,
        fontSize: rem(36),
        lineHeight: rem(46)
    },
    h2: {
        fontFamily: inter,
        fontWeight: 600,
        fontSize: rem(30),
        lineHeight: rem(38)
    },
    h3: {
        fontFamily: inter,
        fontWeight: 600,
        fontSize: rem(24),
        lineHeight: rem(28)
    },
    h4: {
        fontFamily: inter,
        fontWeight: 600,
        fontSize: rem(20),
        lineHeight: rem(26)
    },
    h5: {
        fontFamily: inter,
        fontWeight: 600,
        fontSize: rem(16),
        lineHeight: rem(20)
    },
    h6: {
        fontFamily: inter,
        fontWeight: 600,
        fontSize: rem(14),
        lineHeight: rem(18)
    },
    body1: {
        fontFamily: inter,
        fontWeight: 400,
        fontSize: rem(14),
        lineHeight: rem(18)
    },
    body2: {
        fontFamily: inter,
        fontWeight: 400,
        fontSize: rem(12),
        lineHeight: rem(16)
    },
    /** @internal */ bodyLarge: {
        fontFamily: inter,
        fontWeight: 400,
        fontSize: rem(16),
        lineHeight: rem(22)
    },
    /** @internal */ action1: {
        fontFamily: inter,
        fontWeight: 500,
        fontSize: rem(14),
        lineHeight: rem(18)
    },
    /** @internal */ action2: {
        fontFamily: inter,
        fontWeight: 500,
        fontSize: rem(12),
        lineHeight: rem(16)
    },
    /** @internal */ actionLarge: {
        fontFamily: inter,
        fontWeight: 500,
        fontSize: rem(16),
        lineHeight: rem(22)
    },
    /** @internal */ actionTiny: {
        fontFamily: inter,
        fontWeight: 500,
        fontSize: rem(11),
        lineHeight: rem(12),
        letterSpacing: rem(0.14)
    },
    button: {
        fontFamily: inter,
        fontWeight: 500,
        fontSize: rem(14),
        lineHeight: rem(18),
        textTransform: 'none'
    },
    overline: {
        fontFamily: inter,
        fontWeight: 400,
        fontSize: rem(12),
        lineHeight: rem(16),
        textTransform: 'uppercase'
    },
    /** @internal */ paragraph1: {
        fontFamily: inter,
        fontWeight: 400,
        fontSize: rem(14),
        lineHeight: rem(22)
    },
    /** @internal */ paragraph2: {
        fontFamily: inter,
        fontWeight: 400,
        fontSize: rem(12),
        lineHeight: rem(18)
    },
    /** @internal */ preso1: {
        fontFamily: interTight,
        fontWeight: 600,
        fontSize: rem(120),
        lineHeight: rem(136)
    },
    /** @internal */ preso2: {
        fontFamily: interTight,
        fontWeight: 600,
        fontSize: rem(96),
        lineHeight: rem(112)
    },
    /** @internal */ preso3: {
        fontFamily: interTight,
        fontWeight: 600,
        fontSize: rem(72),
        lineHeight: rem(88)
    },
    /** @internal */ preso4: {
        fontFamily: interTight,
        fontWeight: 600,
        fontSize: rem(44),
        lineHeight: rem(56)
    },
    /** @internal */ preso5: {
        fontFamily: interTight,
        fontWeight: 600,
        fontSize: rem(20),
        lineHeight: rem(32)
    },
    /** @internal */ dataLabel: {
        fontFamily: ibmPlexSans,
        fontWeight: 400,
        fontSize: rem(12),
        lineHeight: rem(16),
        letterSpacing: rem(0.5)
    }
};

//# sourceMappingURL=typography.js.map